module.exports = __webpack_public_path__ + "img/navbar-checklist.a1d87a70.png";